import { AdornerStateType } from 'components/Navigation/SideNav/FilesNav';
import { SyncJobEventType } from 'contexts/WebSocketContext';
import { OrderedMap, Record, Set } from 'immutable';
import { ProjectDriveId } from '../records/ProjectDrive';

export type ProjectDrivesActiveSyncsStatusType =
  | 'ERROR'
  | 'INPROGRESS'
  | 'COMPLETED';

export interface RawProjectDrivesActiveSyncs {
  drivesToStatus: OrderedMap<
    ProjectDriveId,
    ProjectDrivesActiveSyncsStatusType
  >;
}

const defaultValues: RawProjectDrivesActiveSyncs = {
  drivesToStatus: OrderedMap<
    ProjectDriveId,
    ProjectDrivesActiveSyncsStatusType
  >(),
};

export const ProjectDrivesActiveSyncsFactory = Record(
  defaultValues,
  'ProjectDrivesActiveSyncs'
);

export class ProjectDrivesActiveSyncs extends ProjectDrivesActiveSyncsFactory {
  private fileEventToSyncStatus(
    fileEvent: SyncJobEventType
  ): ProjectDrivesActiveSyncsStatusType {
    if (fileEvent === SyncJobEventType.UploadComplete) {
      return 'COMPLETED';
    }
    if (fileEvent === SyncJobEventType.UploadError) {
      return 'ERROR';
    }
    return 'INPROGRESS';
  }

  receivedFileEvent(
    driveId: string,
    fileEvent: SyncJobEventType
  ): ProjectDrivesActiveSyncs {
    const eventStatus = this.fileEventToSyncStatus(fileEvent);

    return new ProjectDrivesActiveSyncs({
      drivesToStatus: this.drivesToStatus.set(driveId, eventStatus),
    });
  }

  adornerState(): AdornerStateType {
    const statusGroups = Set(this.drivesToStatus.toList());

    if (statusGroups.contains('ERROR')) {
      return 'ERROR';
    }

    if (statusGroups.contains('INPROGRESS')) {
      return 'INPROGRESS';
    }

    if (statusGroups.contains('COMPLETED')) {
      return 'COMPLETED';
    }

    return 'NONE';
  }
}
